import leaflet from 'leaflet';
import leafletSleet from 'leaflet-sleep';

leaflet.Map.mergeOptions({
	sleepNote: false,
	sleepOpacity:1
});

leaflet.Control.SleepMapControl.mergeOptions({
	styles: {
		'display': 'none'
	}
});